import React, {createContext, useCallback, useMemo, useState} from 'react'

export interface IVideolabConfigProps {
  children?: React.ReactNode
}

export interface IVideolabConfigContext {
  denoise: boolean
  denoiseThreshold: number
  formatTime: boolean
  isLabelingDisabled: boolean
  updateConfig: (value: Partial<IVideolabConfigContext>) => void
}

const _defaultConfig: Omit<IVideolabConfigContext, 'updateConfig'> = {
  denoise: false,
  denoiseThreshold: 5,
  formatTime: true,
  isLabelingDisabled: false,
}

export const VideolabConfigContext = createContext<IVideolabConfigContext>({
  ..._defaultConfig,
  updateConfig: () => {
    throw new Error('not implemented')
  },
})

export function VideolabConfigWrapper(props: IVideolabConfigProps) {
  const {children} = props

  const [config, setConfig] = useState<Omit<IVideolabConfigContext, 'updateConfig'>>(_defaultConfig)

  const updateConfig = useCallback((value: Partial<IVideolabConfigContext>) => {
    setConfig((prev) => ({
      ...prev,
      ...value,
    }))
  }, [])

  const contextValue = useMemo<IVideolabConfigContext>(
    () => ({
      ...config,
      updateConfig,
    }),
    [config, updateConfig]
  )

  return (
    <VideolabConfigContext.Provider value={contextValue}>{children}</VideolabConfigContext.Provider>
  )
}
